"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandingPresenceEffectHandler = exports.CommandingPresenceEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const Regeneration_1 = require("./Regeneration");
class CommandingPresenceEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.CommandingPresence;
        this.__typeName = "CommandingPresence";
        this.name = "Commanding Presence";
        this.harmful = false;
    }
}
exports.CommandingPresenceEffectArgs = CommandingPresenceEffectArgs;
let CommandingPresenceEffectHandler = class CommandingPresenceEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Health, container.getPercentOfBaseHealth(state.targetId, 20)),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new Regeneration_1.RegenerationEffectArgs("CommandingPresence", container.getPercentOfBaseHealth(state.targetId, 2)),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Will, container.getPercentOfBaseAttributeScore(state.targetId, 10, "Will")),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.effectIds.forEach(effectId => container.cancelEffect(sequence, effectId));
    }
};
CommandingPresenceEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.CommandingPresence)
], CommandingPresenceEffectHandler);
exports.CommandingPresenceEffectHandler = CommandingPresenceEffectHandler;
